module.exports = __webpack_public_path__ + "img/choose_receipt1.7712afd5.png";